
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DomesticSalesModel } from './domestic-sale-model';
// import { DomesticSalesModel } from './domestic-sale-model-dto';



export class DomesticSalesResponseModel extends GlobalResponseObject {
    data?: DomesticSalesModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DomesticSalesModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 